import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "promo" }
const _hoisted_2 = { class: "promo-pic" }
const _hoisted_3 = {
  key: 1,
  class: "promo-pic__flyer"
}
const _hoisted_4 = {
  key: 0,
  class: "promo-placeholder"
}
const _hoisted_5 = {
  key: 0,
  class: "caption-medium thick"
}
const _hoisted_6 = {
  key: 1,
  class: "caption-medium thick uppercase"
}
const _hoisted_7 = {
  key: 1,
  class: "promo-input"
}
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = {
  key: 2,
  class: "promo-apply"
}
const _hoisted_10 = {
  key: 3,
  class: "promo-error"
}
const _hoisted_11 = {
  key: 0,
  class: "promo-error--text desktop"
}
const _hoisted_12 = { class: "caption-medium color-error" }
const _hoisted_13 = { class: "mobile" }
const _hoisted_14 = {
  key: 0,
  class: "promo-note"
}
const _hoisted_15 = { class: "caption-medium color-error" }

import { computed, ref } from "vue";
import BaseButton from "@/components/base/BaseButton.vue";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";
import { useI18n } from "vue-i18n";
import { useStore } from "@/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'BasePromocode',
  emits: ["action"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emit = __emit;

const { t } = useI18n();

const fieldState = ref<"inactive" | "active" | "error" | "applied">("inactive");
const errorText = ref<string>("");
const promoValue = ref<string>("");

const openInput = () => {
  if (fieldState.value === "inactive") {
    fieldState.value = "active";
  }
};

const watchInput = (e: Event) => {
  if (e.target?.value.length && fieldState.value === "error") {
    fieldState.value = "active";
  }
  let value = e.target?.value;
  value = value.replace(/[^a-zA-Z0-9\u0400-\u04FF-]/g, "");
  promoValue.value = value;
};

const applyCode = async () => {
  await store
    .dispatch("tariff/applyPromo", promoValue.value.toUpperCase())
    .then((res) => {
      console.log(res);
      fieldState.value = "applied";
      emit("action");
    })
    .catch((err) => {
      console.log(err);
      fieldState.value = "error";
      switch (err.response.data.code) {
        case 63:
          errorText.value = t("base.promocode.notFound");
          break;
        case 64:
          errorText.value = t("base.promocode.cannotUse");
          break;
        case 65:
          errorText.value = t("base.promocode.alreadyUsed");
          break;
        default:
          errorText.value = t("base.promocode.genericError");
      }
    });
};

const clearCode = () => {
  promoValue.value = "";
  fieldState.value = "active";
};

const classes = computed(() => {
  return {
    inactive: fieldState.value === "inactive",
    active: fieldState.value === "active",
    error: fieldState.value === "error",
    applied: fieldState.value === "applied",
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["promo-wrapper", classes.value]),
      onClick: openInput
    }, [
      _createElementVNode("div", _hoisted_2, [
        (fieldState.value === 'applied')
          ? (_openBlock(), _createBlock(BaseFigureForIcon, {
              key: 0,
              class: "promo-pic__success",
              icon: "check-success",
              color: "customer",
              size: "small"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(BaseIcon, { name: "promo" })
            ]))
      ]),
      (fieldState.value === 'inactive' || fieldState.value === 'applied')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (fieldState.value === 'inactive')
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(t)("base.promocode.hasPromocode")), 1))
              : _createCommentVNode("", true),
            (fieldState.value === 'applied')
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(promoValue.value), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (fieldState.value === 'active' || fieldState.value === 'error')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((promoValue).value = $event)),
              type: "text",
              onInput: watchInput,
              placeholder: _unref(t)('base.promocode.placeholder'),
              minlength: "4",
              maxlength: "20",
              class: "caption-medium thick"
            }, null, 40, _hoisted_8), [
              [_vModelText, promoValue.value]
            ])
          ]))
        : _createCommentVNode("", true),
      (fieldState.value === 'active')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(BaseButton, {
              class: "desktop",
              title: _unref(t)('base.promocode.apply'),
              size: "small",
              disabled: promoValue.value.length < 4,
              onClick: applyCode
            }, null, 8, ["title", "disabled"]),
            _createVNode(BaseFigureForIcon, {
              class: "mobile",
              icon: "arrow",
              color: "primary",
              disabled: promoValue.value.length === 0,
              onClick: applyCode,
              "is-button": ""
            }, null, 8, ["disabled"])
          ]))
        : _createCommentVNode("", true),
      (fieldState.value === 'error')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (fieldState.value === 'error')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(errorText.value), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "promo-error--close",
              onClick: clearCode
            }, [
              _createVNode(BaseIcon, { name: "close" })
            ])
          ]))
        : _createCommentVNode("", true),
      (fieldState.value === 'applied')
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: "promo-cancel color-secondary",
            onClick: clearCode
          }, [
            _createVNode(BaseIcon, { name: "close" })
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_13, [
      (fieldState.value === 'error')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, _toDisplayString(errorText.value), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})